var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"list"}},[_c('div',{staticClass:"owal-list__container"},[_vm._t("default",function(){return [(_vm.item)?_c('div',{staticClass:"owal-list__content_text"},[_vm._v(" "+_vm._s(this.item.title)+" ")]):_vm._e(),_c('owal-list-row-accessory',{staticClass:"owal-list__accessory",attrs:{"type":_vm.accessoryType}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }